import React from 'react';
import Button from './Button/Button';
import { motion } from 'framer-motion';
import { PopupButton } from "react-calendly";

function FeatureSection({ image, title, description, reverse = false, eyebrow, showEyebrow = false }) {
  return (
    <div className="w-full bg-white py-20">
      <div
        className={`max-w-7xl mx-auto px-6 flex flex-col-reverse lg:flex-row ${
          reverse ? 'lg:flex-row-reverse' : ''
        } items-center gap-12`}
      >
        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.1 }}
          className="flex-1 text-center grid gap-8 lg:text-left"
        >
          {showEyebrow && (
            <h3 className="text-sm text-[#7f56d9] font-semibold -mb-4">{eyebrow}</h3>
          )}
          <h2 className="text-3xl md:text-4xl font-medium text-gray-900">{title}</h2>
          <p className="text-gray-600 text-lg">{description}</p>
          <div className="flex justify-center lg:justify-start gap-4">
            <Button variant="primary">Get started</Button>
            <Button variant="secondary" calendly>Book a demo</Button>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.3 }}
          className="flex-1"
        >
          <img
            src={image}
            alt={title}
            loading="lazy"
            className="w-full max-w-2xl mx-auto object-contain"
          />
        </motion.div>
      </div>
    </div>
  );
}

export default FeatureSection;
